module.exports = __webpack_public_path__ + "static/media/pistol-poem.dfc62e51.txt";